import { useState } from "react";
import { ListGroup, ListGroupItem } from "reactstrap";
import { BsChevronDown, BsChevronRight } from "react-icons/bs";

import { routes } from "@/utils/routes";
import {
  collections,
  categoryMapping,
  articleMapping,
} from "./help-articles-data";
import Link from "next/link";

interface SidebarProps {
  collectionId: string;
  categoryId?: string;
}

export const Sidebar = ({ collectionId, categoryId }: SidebarProps) => {
  const [activeCollection, setActiveCollection] = useState(collectionId);

  const [activeCategory, setActiveCategory] = useState(categoryId);

  return (
    <>
      <ListGroup>
        {collections.map((col, ci) => {
          return (
            <ListGroupItem key={ci}>
              <span
                onClick={() =>
                  setActiveCollection((prev) =>
                    prev === col.link ? "" : col.link
                  )
                }
              >
                {col.title}{" "}
                {activeCollection === col.link ? (
                  <BsChevronDown />
                ) : (
                  <BsChevronRight />
                )}
              </span>
              {activeCollection === col.link && (
                <ul>
                  {collections
                    .find((c) => c.link === col.link)
                    ?.categories.map((ca, cai) => (
                      <li key={cai}>
                        <span
                          onClick={() =>
                            setActiveCategory((prev) => (prev === ca ? "" : ca))
                          }
                        >
                          {categoryMapping[ca].title}{" "}
                          {activeCategory === ca ? (
                            <BsChevronDown />
                          ) : (
                            <BsChevronRight />
                          )}
                        </span>

                        {activeCategory === ca && (
                          <ul>
                            {categoryMapping[ca].articles.map((a, ai) => (
                              <li key={ai}>
                                <Link
                                  href={`${routes.help}/${col.link}/${ca}/${a}`}
                                >
                                  {articleMapping[a].title}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                </ul>
              )}
            </ListGroupItem>
          );
        })}
      </ListGroup>
    </>
  );
};
